export const experienceData = [
    {
        id: 1,
        company: 'Wolf 3D Printing services pvt. ltd -- Pune',
        jobtitle: 'Internship ',
        startYear: 'Jan 2020',
        endYear: 'Feb 2020',
        Description1:"~ Worked on Part designing in CATIA and TINKERCAD.",
        Description2:"~ Learned about Slicing and other operations in CURA and FLASHFORGE.",
        Description3:"~ And have closely worked on 3D printing operations, printing materials properties, Post Processing, Maintenance and Interaction with Client.",
        skills: "HTML · Mechanical Engineering · 3D Modeling · Total Quality Management (TQM) · Team Management"
    },
    {
        id: 2,
        company: 'CommScope ( ANDREW TELECOMMUNICATIONS INDIA PVT.LTD ) -- GOA',
        jobtitle: 'Internship ',
        startYear: 'Feb 2019',
        endYear: 'Mar 2019',
        Description1:"Received training on Base Station and Microwave antenna manufacturing, Quality Testing and its Production.",
        Description2:"",
        Description3:"",
        skills: " Leadership · Mechanical Engineering · Total Quality Management (TQM) · Team Management"
    },
    {
        id: 3,
        company: 'IC Engine Workshop -- KLECET CHIKKODI ',
        jobtitle: 'Organized 2 Days Workshop',
        startYear: '14 Oct 2019',
        endYear: '15 Oct 2019',
        Description1:"As a Trainer,I trained students regarding the working of IC Engine and its parts.",
        Description2:"",
        Description3:"",
        skills: "Leadership · Mechanical Engineering · Total Quality Management (TQM) · Team Management · Time Management · Crowd Handeling"
    },
    {
        id: 4,
        company: 'Advanced Level-Automobile & IC Engine Design Workshop –- NIT Warangal, Telangana',
        jobtitle: 'National level Workshop  ',
        startYear: '15 Mar 2019',
        endYear: '17 Mar 2019',
        Description1:"I completed my training on IC engine Design and Development Process. And was appreciated by the manager of AUTOFREAK INDIA for my Fast - Proficient work.",
        Description2:"",
        Description3:"",
        skills: "Leadership · Total Quality Management · Team Management · Time Management"
    },
    {
        id: 5,
        company: 'Workshop Lead By Royal Enfield –- MMEC Belgaum, KA',
        jobtitle: 'National level Workshop ',
        startYear: '25 Mar 2018',
        endYear: '26 Mar 2018',
        Description1:"This workshop of 2 days was organised by Royal Enfield | Vanisha Honda | Mahindra Sutaria | Ghadi Enterprises | SMART – An Academy For Career Enhancement | Om Gurudev Service Center | SC Motors | Polyhydron Foundation | VOTC .",
        Description2:"I completed training in an advanced Level Automobile Development Process. And was awarded as best participant from the manager of MERCEDES BENZ.",
        Description3:"",
        skills: "TQM · 4,6,8 stroke Engine Assembly and Working"
    }
]